import { render } from "./IngresoRentaForm.vue?vue&type=template&id=6990a5ce&scoped=true"
import script from "./IngresoRentaForm.vue?vue&type=script&lang=js"
export * from "./IngresoRentaForm.vue?vue&type=script&lang=js"

import "./IngresoRentaForm.vue?vue&type=style&index=0&id=6990a5ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6990a5ce"]])

export default __exports__